import type { LocaleId } from '../types';
import { authLocales, type AuthLocaleKey } from './auth';
import { commonLocales, type CommonLocaleKey } from './common';
import { mobileLocales, type MobileLocaleKey } from './mobile';
import { radioRemoteLocales, type RadioRemoteLocaleKey } from './radioRemote';

type ModuleKey<Namespace extends string, Key> =
  Key extends string ? `${Namespace}.${Key}` : never;

export type I18nKey =
  | ModuleKey<'common', CommonLocaleKey>
  | ModuleKey<'auth', AuthLocaleKey>
  | ModuleKey<'mobile', MobileLocaleKey>
  | ModuleKey<'radioRemote', RadioRemoteLocaleKey>;

export type LocaleMessages = Record<I18nKey, string>;

function prefixMessages(
  namespace: string,
  messages: object,
): Record<string, string> {
  const messageRecord = messages as Record<string, string>;
  return Object.keys(messageRecord).reduce<Record<string, string>>((result, key) => {
    result[`${namespace}.${key}`] = messageRecord[key];
    return result;
  }, {});
}

function buildLocale(locale: LocaleId): LocaleMessages {
  return {
    ...prefixMessages('common', commonLocales[locale]),
    ...prefixMessages('auth', authLocales[locale]),
    ...prefixMessages('mobile', mobileLocales[locale]),
    ...prefixMessages('radioRemote', radioRemoteLocales[locale]),
  } as LocaleMessages;
}

export const locales: Record<LocaleId, LocaleMessages> = {
  zh_CN: buildLocale('zh_CN'),
  zh_HK: buildLocale('zh_HK'),
  en_US: buildLocale('en_US'),
  ru_RU: buildLocale('ru_RU'),
  es_ES: buildLocale('es_ES'),
  fr_FR: buildLocale('fr_FR'),
  ja_JP: buildLocale('ja_JP'),
};

export { authLocales, commonLocales, mobileLocales, radioRemoteLocales };
